import React, { Component } from 'react';
import './ProductsRecipeList.css';
import Timeline from '../timeline/Timeline'
import ENV from '../../environments/environment'
import ModalProductDescription from '../modal-product-description/ModalProductDescription'
import landingService from '../../services/landing.service'

declare var $;
class ProductsRecipeList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      products: [],
      selectedProducts:[],
      error: '',
      checked: true,
      loading: true,
      total: 0,
      step: 1,
      auth: false,
      loadingStep: false,
      minProducts: true,
      selectedProduct: [],
      search: '',
      searchProducts: []
    }
    this.selectProducts = this.selectProducts.bind(this)
    this.changeProductUnits = this.changeProductUnits.bind(this);
    this.verifyProductUnits = this.verifyProductUnits.bind(this)
    this.selectProduct = this.selectProduct.bind(this)
    this.getAlgoliaProducts = this.getAlgoliaProducts.bind(this)
    this.stepBack = this.stepBack.bind(this);
  }

   componentDidMount() {
     this.setState({
       loadingStep: false
     })
      setTimeout(() => {$('.filled-in').trigger('click')} ,2000)

     this.componentWillReceiveProps(this.props)

   }


   selectSearchProduct(product) {

     let products = this.state.products;
     let total = this.state.total
     total = total + product.price;
     products.push(product)
     this.setState({
       products,
       total,
       search: ''
     })
   }

  async getAlgoliaProducts(event) {
    let query = event.target.value
     this.setState({
       search: query,
     })
    let response = await landingService.getAlgoliaProducts(query, this.props.store_id);
    let searchProducts = response.hits

    this.setState({
     searchProducts
    })
   }

   componentWillReceiveProps(nextProps) {
     let products = nextProps.products;
     let store_id = nextProps.store_id
     let loading = true
     if( nextProps.products.length > 0) {
       loading = false
     }
     let total = 0
     for(let product of products) {
       total = total + product.price
     }
     this.setState({
       loading,
       products,
       total,
       selectedProducts: products,
       store_id
     })
   }


  selectProducts(authType) {
    this.props.screen(authType)
    if(this.state.minProducts) {
      this.setState({
        loadingStep: true,
        error: ''
      })

     let selectedProducts = []
     let products = JSON.parse(JSON.stringify(this.state.products))
     for(let product of products) {
       if(product.units) {
         selectedProducts.push(product)
       }
     }
     for( let product of selectedProducts) {
       product.units = product.units;
       product.unit_price =  product.price;
       product.total_price = product.total_price;
       product.sale_type = 'U';
       product.toppings = [];
       delete product.description;
       //delete product.name;
       //delete product.original_price;
     }
     this.props.selected(selectedProducts)
   } else {
     this.setState({
       error: 'Debes escoger por lo menos un producto'
     })
   }
  }

  changeProductUnits(action , product) {
    let total;
    let original_price
    if(product.original_price) {
      original_price = product.original_price
    } else {
      original_price = product.price
    }
    if(action === 'sum') {
     product.units++;
     if(product.units < 1) {
       total = this.state.total + product.price;
     } else {
       total = this.state.total + parseInt(original_price);
     }
     this.setState({
       total
     })
    } else {
      if(product.units > 0) {
        product.units--;
        if(product.units < 1) {
          total = this.state.total - product.price;
        } else {
          total = this.state.total - parseInt(original_price);
        }
        this.setState({
          total
        })
      }
    }
    if(product.units < 1) {
      product.total_price = 0
    } else {
      product.total_price = 1 * product.price + ( (product.units - 1) * original_price )
    }
    this.verifyProductUnits()
  }

  verifyProductUnits() {
    let units = 0;
    let minProducts
    for(let product of this.state.products) {
      units = units + product.units
    }
    if(units > 0) {
      minProducts = true;
    } else {
      minProducts = false;
    }
    this.setState({
      minProducts
    })
  }

  selectProduct(product) {
    this.setState({
      selectedProduct: product
    })
    $('#product').modal('open');
  }


  stepBack() {
    let step = this.props.step;
    step--
    this.props.continue(step)
  }


  render() {
     let products = [];
     let loadingProducts = [];
     let cont = 0;
     let original_price;
     let original = false;
     let product_image ;
     for(let product of this.state.products) {
       cont++
       if(product.image === 'NO-IMAGE') {
          product_image = "http://blog.1800gotjunk.com/wp-content/themes/1800gotjunk/img/default-placeholder.png"
       } else {
        product_image = ENV.getImageUrl() + product.image;
       }
       if(product.original_price) {
         original_price = product.original_price;
         original = true;
       } else {
         original_price = product.price
       }
       if(!product.total_price) {
          product.total_price = product.price
       }
       if(!product.units && product.units !== 0) {
          product.units = 1
       }
       products.push(

         <li className="collection-item avatar" key={cont}>
           <img onClick={() => this.selectProduct(product)} src={product_image} alt="" className="circle"/>
           <span onClick={() => this.selectProduct(product)} className="title prod truncate">{product.name}</span>
             { original &&   <p> {( parseInt(original_price) !== product.price ) && <span> ${product.original_price}</span> } ${product.total_price}
                </p> }
            {!original && <p> ${product.total_price}</p>  }
            <a className="secondary-content qty">
              <span onClick={() => this.changeProductUnits('less', product)}>  - </span>
              <span> {product.units} </span>
              <span onClick={() => this.changeProductUnits('sum', product)}>+ </span>
           </a>
         </li>


       )
     }


     let searchProducts= [];
     let cont_search = 0;
     for(let product of this.state.searchProducts) {
       let product_image
       cont_search ++
       if(product.image === 'NO-IMAGE') {
         product_image = "http://blog.1800gotjunk.com/wp-content/themes/1800gotjunk/img/default-placeholder.png"
       } else {
          product_image = ENV.getImageUrl() + product.image;
       }
       searchProducts.push(

         <li className="collection-item avatar" key={cont_search}>
           <img  src={product_image} alt="" className="circle"/>
           <span className="title truncate">{product.name}</span>
              <p>${product.price}</p>
            <a className="secondary-content add">
               <a className="btn continue waves-effect waves-light" onClick={ () => this.selectSearchProduct(product)}>Agregar</a>
           </a>
         </li>
       )
     }


     let i;

     for(let product of [0,1,2,3,4,5,6,7,8,9])  {
       loadingProducts.push(
         <li className="collection-item avatar animated pulse infinite" key={product}>
           <img  src="http://blog.1800gotjunk.com/wp-content/themes/1800gotjunk/img/default-placeholder.png" alt="" className="circle"/>
           <span  className="title"><div className="loading-text"></div></span> <br/>
           <p>  <div className="loading-text"></div>
           </p>
           <a className="secondary-content qty">
             <span >  - </span>
             <span> 0 </span>
             <span>+ </span>
          </a>
         </li>
         )
     }
    return (
      <section>
          <header>

            <nav>
             <div className="nav-wrapper no-color">
               <a  className="brand-logo center">Ingredientes</a>
               <a onClick={this.stepBack} className="button-collapse"><i className="material-icons">keyboard_arrow_left</i></a>
             </div>
            </nav>


         <div className="steps center  animated fadeIn  row">
           <div className="col s12">
           <ul className="timeline" id="timeline">
             <li className="li complete">
               <div className="timestamp">
                 <span className="author">Ingresar</span>
               </div>
               <div className="status">

               </div>
             </li>
             <li className="li ">
               <div className="timestamp">
                 <span className="author">Envio</span>
               </div>
               <div className="status">
               </div>
             </li>
             <li className="li">
               <div className="timestamp">
                 <span className="author">Ordenar</span>
               </div>
               <div className="status">
               </div>
             </li>
            </ul>
         </div>
         </div>
        </header>
      <div className="products-box">
          <h4> Agrega tus ingredientes</h4>
           <ul className="collection">
            {products}
            {this.state.loading && loadingProducts}
           </ul>
        </div>
       { /*<div className="products-box">
           <h4 className="center">Agrega más productos</h4>
             <div className="input-field container">
               <input id="search" type="text" className="autocomplete" value={this.state.search} onChange={this.getAlgoliaProducts}/>
               <label htmlFor="search">Buscar</label>
             </div>
        { this.state.search != ''  &&  <ul className="collection algolia">
              {searchProducts}
            </ul> }
          </div> */ }
        <div className="action center container row">
          {this.state.loadingStep && <div className="progress">
              <div className="indeterminate"></div>
          </div> }
          { this.state.error !== '' && <p  className="error animated shake">{this.state.error}</p> }
           
         <div className="col s6">
            <a onClick={ () => this.selectProducts('login') } className="waves-effect waves-light btn"> Ingresar </a>
        </div>
        <div className="col s6">
            <a onClick={() => this.selectProducts('signup')} className="waves-effect waves-light btn btn-inverse">  Registrarme  </a>
        </div>
           {  /* <a className={"btn continue continue-store btn-orange waves-effect waves-light  " + (this.state.loadingStep ? 'disabled' : ' ')}  onClick={this.selectProducts}>Continuar  ${this.state.total}</a> */ }
        </div>
        <ModalProductDescription product={this.state.selectedProduct}/>
      </section>
      /* <div className="cart text-center">
           <div className="products-cart">
            <i className="fa fa-shopping-basket" aria-hidden="true"></i> <span> { this.state.selectedProducts.length }</span>
           </div>
           <div className="total-cart">
            Total: <span>${this.state.total} </span>
           </div>
         </div>
         <div className="action text-center" id="next">
           { this.state.error !== '' && <p  className="error animated shake">{this.state.error}</p> }
             <a className="btn continue continue-store"  onClick={this.selectProducts}  data-loading-text="Cargando...">¿A dónde te lo llevamos?</a>
         </div>
       </div>
       </section> */

    );
  }
}


export default ProductsRecipeList;



// WEBPACK FOOTER //
// ./src/components/products-recipe-list/ProductsRecipeList.js